export const ACTION_TYPES = {
    OPEN_LOADING: '[loading] action open',
    CLOSE_LOADING: '[loading] action close',
};
